import React, { useState, useRef, useEffect } from "react"
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Dimensions,
  Animated,
  Platform
} from "react-native"

import Modal from "modal-enhanced-react-native-web"
import { Ionicons } from "@expo/vector-icons"
import ExistingFlowsStep from "./ExistingFlowsStep"
import { PropertySelectionStep } from "./PropertySelectionStep"
import IssueFormStep from "./IssueFormStep"
import { addIssue, editIssue } from "../../redux/action/maintenance.actions"
import { useDispatch } from "react-redux"
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard"
import { Edit } from "@material-ui/icons"
import { showSuccesToast } from "../../screens/tenants/tenantOnboarding/helpers"

const { width } = Dimensions.get("window")

const steps = [
  "Select Property",
  "Existing Flow",
  "Issue Details"
]

interface Props {
  open: boolean
  onClose: () => void
  onIssueAdded: () => void,
  refresh: () => void,
  flowId: any,
  slectedItems: any
}

export default function EditIssueModal({
  open,
  onClose,
  onIssueAdded,
  refresh,
  slectedItems,
  flowId
}: Props) {
  console.log("slectedItems", slectedItems)
  const dispatch = useDispatch()

  const [activeStep, setActiveStep] = useState(0)
  const [payload, setPayload] = useState<any>({})


  const fadeAnim = useRef(new Animated.Value(0)).current



  const handleClose = () => {
    setPayload({})
    onClose()
  }

  const handleBack = () => {
    if (activeStep > 0) setActiveStep(prev => prev - 1)
  }

  return (
    <Modal
      isVisible={open}
      backdropTransitionInTiming={200}
      backdropTransitionOutTiming={200}
      useNativeDriver={false}
      style={{ margin: 0 }}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>

          {/* HEADER */}
          <View style={styles.header}>
            {slectedItems?.open_flow_maintenance_issue_id ?
              <Text style={styles.title}>
                Edit Maintenance Issue
              </Text> :
              <Text style={styles.title}>
                Create Maintenance Issue
              </Text>}
            <TouchableOpacity onPress={handleClose}>
              <Ionicons name="close" size={24} color={COLORS.primary} />
            </TouchableOpacity>
          </View>

          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={styles.content}
            showsVerticalScrollIndicator={false}
          >

            <IssueFormStep
              selectedFlowSummary={payload.selectedFlowSummary}
              slectedItems={{
                title: slectedItems?.title,
                description: slectedItems?.description,
                issue_images: slectedItems?.images,
                date_opened: slectedItems?.date_opened,
                videos: [],
                category_id: slectedItems?.category_id,
                room_type_id: slectedItems?.room_type_id,
                open_flow_maintenance_issue_id: slectedItems?.open_flow_maintenance_issue_id
              }}
              onBack={handleBack}
              onSubmit={(data) => {
                if( slectedItems?.open_flow_maintenance_issue_id){
                  const payloadToSend = {
                    title: data.title,
                    date_opened: new Date(data.date_opened).toISOString(),
                    videos: [],
                    images: data.issue_images,
                    description: data.description,
                    category_id: Number(data.category_id),
                    room_type_id: Number(data.room_type_id),
                    open_flow_maintenance_issue_id: slectedItems?.open_flow_maintenance_issue_id
                  }
  
                  dispatch(editIssue(payloadToSend, () => {
                    showSuccesToast("Details updated successfully!")
                    onIssueAdded()
                    handleClose()
                  }))
                }else{
                  const payloadToSend = {
                    title: data.title,
                    date_opened: new Date(data.date_opened).toISOString(),
                    videos: [],
                    images: data.issue_images,
                    description: data.description,
                    category_id: Number(data.category_id),
                    room_type_id: Number(data.room_type_id),
                    openflow_id: flowId
                  }
  
                  dispatch(addIssue(payloadToSend, () => {
                    onIssueAdded()
                    handleClose()
                  }))
                }
              
              }}
            />

          </ScrollView>

        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({

  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.4)"
  },

  container: {
    width: width > 1000 ? 950 : "95%",
    height: width > 1000 ? 680 : "88%",
    backgroundColor: "#fff",
    borderRadius: 22,
    overflow: "hidden",
    ...Platform.select({
      web: {
        boxShadow: "0 20px 50px rgba(109, 8, 192, 0.15)"
      },
      default: {
        elevation: 10
      }
    })
  },

  header: {
    padding: 22,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: "#F3F4F6"
  },

  title: {
    fontSize: 20,
    fontWeight: "700",
    color: COLORS.primary
  },

  progressWrapper: {
    paddingHorizontal: 30,
    paddingTop: 25,
    paddingBottom: 10
  },

  progressBackground: {
    height: 8,
    backgroundColor: "#F1E6FB",
    borderRadius: 10,
    overflow: "hidden",
    marginBottom: 25
  },

  progressActive: {
    height: "100%",
    backgroundColor: COLORS.primary,
    borderRadius: 10
  },

  stepsRow: {
    flexDirection: "row",
    justifyContent: "space-between"
  },

  stepItem: {
    alignItems: "center",
    flex: 1
  },

  circle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#E9D8F7",
    justifyContent: "center",
    alignItems: "center"
  },

  circleActive: {
    backgroundColor: "#6D08C0",
    shadowColor: "#6D08C0",
    shadowOpacity: 0.4,
    shadowRadius: 8,
    elevation: 5
  },

  circleCompleted: {
    backgroundColor: COLORS.primary
  },

  circleText: {
    color: "#fff",
    fontWeight: "700"
  },

  stepLabel: {
    marginTop: 8,
    fontSize: 12,
    color: "#9CA3AF",
    textAlign: "center"
  },

  stepLabelActive: {
    color: COLORS.primary,
    fontWeight: "700"
  },

  content: {
    padding: 10,
    paddingBottom: 40
  }

})
